import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastComponent } from "../../../../../shared/components/toast/toast.component";
import { AdminTopbarComponent } from "../../../components/admin-topbar/admin-topbar.component";
import { AdminNavigationComponent } from "../../../components/admin-navigation/admin-navigation.component";
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { CreateEditIndicatorComponent } from "../../../components/upsell-engine/create-edit-indicator/create-edit-indicator.component";
import { SalesEngineDataService } from '../../../../../core/services/sales-engine-data.service';
import { IndicatorGet } from '../../../../../core/interfaces/sales-engine-interfaces';
import { CommonModule } from '@angular/common';
import { SalesEngineService } from '../../../../../core/api/sales-engine.service';
import { lastValueFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiErrorService } from '../../../../../core/api/api-error.service';
import { DeleteConfirmationDialogComponent } from '../../../../../shared/dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component';

@Component({
  selector: 'app-admin-indicators-page',
  standalone: true,
  imports: [ToastComponent, AdminTopbarComponent, AdminNavigationComponent, CustomButtonComponent, TranslocoPipe, CreateEditIndicatorComponent, CommonModule, DeleteConfirmationDialogComponent],
  templateUrl: './admin-indicators-page.component.html',
  styleUrl: './admin-indicators-page.component.css'
})
export class AdminIndicatorsPageComponent implements OnInit {
  constructor(private salesEngineData: SalesEngineDataService, private salesEngine: SalesEngineService, private apiError: ApiErrorService, private cdRef: ChangeDetectorRef) { }

  @ViewChild(ToastComponent) toast?: ToastComponent;

  @ViewChild(DeleteConfirmationDialogComponent) deleteDialog!: DeleteConfirmationDialogComponent;
  @ViewChild('editCreateRef') editCreateRef!: ElementRef;

  isEditCreateOpen: boolean = false;
  isEditing: boolean = false;
  selectedIndicator?: IndicatorGet;

  get indicators(): Array<IndicatorGet> {
    return this.salesEngineData.getIndicators();
  }

  reloadIndicators = () => this.salesEngineData.reloadIndicators();

  ngOnInit(): void {
    this.cdRef.detectChanges();
  }

  createIndicator() {
    if (this.isEditCreateOpen) {
      this.isEditCreateOpen = false;
      this.cdRef.detectChanges();
    }

    this.isEditCreateOpen = true;
    this.cdRef.detectChanges();



    this.isEditing = false;
    this.selectedIndicator = undefined;

    this.editCreateRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  editIndicator(indicator: IndicatorGet) {
    if (this.isEditCreateOpen) {
      this.isEditCreateOpen = false;
      this.cdRef.detectChanges();
    }

    this.isEditCreateOpen = true;
    this.cdRef.detectChanges();

    this.isEditing = true;
    this.selectedIndicator = indicator;

    this.editCreateRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  async deleteIndicator(indicator: IndicatorGet) {
    if (!await this.deleteDialog.openModal()) {
      return;
    }

    try {
      await lastValueFrom(this.salesEngine.deleteIndicator(indicator.id));

      this.reloadIndicators();
    } catch (error) {
      var crid = 'UNKNOWN-CRID';
      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      return;
    }
  }
}
